import { render, staticRenderFns } from "./AppointmentWaitingList.vue?vue&type=template&id=5bf96c72&"
import script from "./AppointmentWaitingList.vue?vue&type=script&lang=js&"
export * from "./AppointmentWaitingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports